export default __webpack_public_path__ + "static/media/olivos1_c.c7fe7727.jpg";